module.exports = __webpack_public_path__ + "img/48.38628b57.png";